import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import BurgerMenu from "./BurgerMenu";
import "../scss/Navbar.scss";
import "../scss/BurgerMenu.scss"; // Import the styles for BurgerMenu
import expertefyText from "../assets/svg/expertefy_text.svg";
import expertefyLogo from "../assets/svg/logo.svg";
import LinkdinLogo from "../assets/svg/linkdin.svg";

const Navbar = () => {
    const [isMobile, setIsMobile] = useState(
        window.matchMedia("(max-width: 768px)").matches
    );
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const updateMobile = () => {
            setIsMobile(window.matchMedia("(max-width: 768px)").matches);
        };

        // Add event listener to update mobile state on screen resize
        window.addEventListener("resize", updateMobile);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener("resize", updateMobile);
        };
    }, []);

    useEffect(() => {
        const pageTitles = {
            "/services": "Services - Expertefy",
            "/clients": "Clients - Expertefy",
            "/experts": "Experts - Expertefy",
            "/success-stories": "Success Stories - Expertefy",
            "/about-us": "About Us - Expertefy",
            "/contact-us": "Contact Us - Expertefy",
            "/": "Home - Expertefy",
        };

        const title = pageTitles[location.pathname] || "Expertefy";
        document.title = title;
    }, [location.pathname]);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="header w-full">
            <header
                className={`flex container navbar-fading sticky top-0 gap-5 ${isMobile
                        ? "justify-between items-center"
                        : "justify-around self-center"
                    } max-md:flex-wrap max-md:max-w-full`}
            >
                <Link
                    to="/"
                    onClick={() => {
                        setIsOpen(false);
                    }}
                >
                    <div className="flex space-x-2 text-xl font-semibold light-title whitespace-nowrap my-[12px] max-w-[192px]">
                        <img
                            alt="Expertefy Logo"
                            src={expertefyLogo}
                            className="shrink-0 aspect-[1.04] w-[57px]"
                        />
                        <span className="my-auto hidden md:block">
                            <h3 className="uppercase font-semibold text-[#6369C4] text-[21px]">Expertefy</h3>
                        </span>
                    </div>
                </Link>
                <BurgerMenu toggleMenu={toggleMenu} isOpen={isOpen} />

                <nav
                    className={`gap-5 items-center my-auto text-lg text-color max-md:flex-col max-md:items-start max-md:w-full ${isOpen ? "flex" : "hidden"
                        } md:flex md:gap-5`}
                >
                    {[
                        { to: "/services", label: "Services" },
                        { to: "/clients", label: "Clients" },
                        { to: "/experts", label: "Experts" },
                        { to: "/success-stories", label: "Success Stories" },
                        { to: "/about-us", label: "About Us" },
                        { to: "/contact-us", label: "Contact Us" },
                    ].map((link) => (
                        <Link
                            key={link.to}
                            to={link.to}
                            onClick={() => {
                                setIsOpen(false);
                            }}
                            className={`nav-link text-color self-stretch my-auto ${isMobile ? "mx-auto" : ""} ${location.pathname === link.to ? "active" : ""
                                }`}
                        >
                            {link.label}
                        </Link>
                    ))}
                    <a
                        href="https://www.linkedin.com/company/expertefy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`nav-link self-stretch my-auto ${isMobile ? "mx-auto" : ""}`}
                    >
                        <img src={LinkdinLogo} alt="LinkedIn" />
                    </a>
                </nav>
            </header>
            <div className="w-full bg-light-indigo shadow-xl min-h-[2px] max-md:max-w-full"></div>
        </div>
    );
};

export default Navbar;
